// extracted by mini-css-extract-plugin
export default {"meals":"Project_meals__aLX2v","meals-appear":"Project_meals-appear__bds3V"};